<template>
    <div class="container-fluid h-100">
        <div v-if="$can('statistics read')" class="row justify-content-center h-100">
            <div class="default-page-width h-100">
                <div class="card card-default h-100">
                    <div class="card-header">{{$t('statistics.title')}}</div>
                    <div class="card-body">
                        <div class="h-100">
                            <Splitter
                                :style="{ height: '100%' }"
                                :panes="horizontalPanes"
                                :orientation="'horizontal'"
                                @change="onHorizontalChange"
                            >
                                <template v-slot:left>
                                    <div class="pane-content">
                                        <KMenu
                                            class="p-2"
                                            :items="menuItems"
                                            :vertical="true"
                                            :style="{
                                              display: 'inline-block',
                                            }"
                                            @select="onMenuSelect"
                                        />
                                    </div>
                                </template>
                                <template v-slot:center>
                                    <div class="pane-content">
                                        <div v-if="(activeChart == 'countRentsPerDateRange')">
                                            <RequestsPerTimeFrame></RequestsPerTimeFrame>
                                        </div>
                                        <div v-if="(activeChart == 'countOrdersPerDateRange')">
                                            <OrdersPerTimeFrame></OrdersPerTimeFrame>
                                        </div>
                                        <div v-if="(activeChart == 'EquipmentRentedCountPerTimeFrame')">
                                            <EquipmentRentedCountPerTimeFrame></EquipmentRentedCountPerTimeFrame>
                                        </div>
                                        <div v-if="(activeChart == 'countEquipmentRents')">
                                            <EquipmentRentsPerTimeFrame></EquipmentRentsPerTimeFrame>
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:right>
                                    <div class="pane-content">
                                        <h3>Right pane</h3>
                                        <p>Resizable and collapsible.</p>
                                    </div>
                                </template>
                            </Splitter>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('statistics read')">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>
// Template für Actions


import {
    Chart,
    ChartTitle,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisTitle,
    ChartCategoryAxisItem,
} from "@progress/kendo-vue-charts";
import "hammerjs";

import Grid from '@bryntum/grid-vue';
import RmsObjectsGridColumnImage from '../rmsobjects/rms-objects-grid-column-image.js';
import RmsObjectsGridColumnCurrentStatus from '../rmsobjects/rms-objects-grid-column-current-status.js';
import RmsObjectsGridColumnRequestable from '../rmsobjects/rms-objects-grid-column-requestable.js';
import zipcelx from "zipcelx";
import {validate} from "vee-validate";
import ObjectLister from "../orders/object-lister";
//import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { Splitter, Menu } from '@progress/kendo-vue-layout';
import { Button } from '@progress/kendo-vue-buttons';
import { process } from '@progress/kendo-data-query';
import { DateRangePicker } from '@progress/kendo-vue-dateinputs';

import OrdersPerTimeFrame from "./OrdersPerTimeFrame.vue";
import RequestsPerTimeFrame from './RequestsPerTimeFrame.vue'
import EquipmentRentsPerTimeFrame from "./EquipmentRentsPerTimeFrame.vue";
import EquipmentRentedCountPerTimeFrame from "./EquipmentRentedCountPerTimeFrame.vue";

export default {
    name: "statistics-home",
    components:{
        EquipmentRentedCountPerTimeFrame,
        Chart,
        ChartTitle,
        ChartSeries,
        ChartSeriesItem,
        ChartCategoryAxis,
        ChartCategoryAxisTitle,
        ChartCategoryAxisItem,
        Splitter,
        DateRangePicker,
        ObjectLister,
        'KMenu': Menu,
        Grid,
  //      'grid-toolbar': GridToolbar,
        kbutton: Button,

        OrdersPerTimeFrame,
        RequestsPerTimeFrame,
        EquipmentRentsPerTimeFrame
    },
    data() {
        return {
            activeChart: 'countOrdersPerDateRange',

            firstSeries: [12, 25, 32, 40, 68, 82, 96, 102, 98, 42, 22, 10],
            categories: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],


            horizontalPanes: [
                { size: '19%', content: 'left', collapsible: false, resizable: true},
                { content: 'center' },
            ],
            menuItems: [
                {
                    text: this.$t("statistics.orders-per-period"),
                    value: "countOrdersPerDateRange",
                    cssClass: "btn btn-light mt-2 ml-2 mr-2",
                },
                {
                    text: this.$t("statistics.applications-per-period"),
                    value: "countRentsPerDateRange",
                    cssClass: "btn btn-light mt-2 ml-2 mr-2",
                },
                {
                    text: this.$t("statistics.rented-equipment-per-period"),
                    value: "EquipmentRentedCountPerTimeFrame",
                    cssClass: "btn btn-light mt-2 ml-2 mr-2",
                },
                {
                    text: this.$t("statistics.order-count-per-equipment-and-period"),
                    value: "countEquipmentRents",
                    cssClass: "btn btn-light mt-2 ml-2 mr-2",
                },
            ],
        };
    },
    computed: {
        getPresetTimes(){
            console.log("form-order: getPresetTimes", {from: this.form.from, until: this.form.until});
            if(this.presetdata != undefined && this.presetdata !== false && this.presetdata.hasOwnProperty("startDate") && this.presetdata.hasOwnProperty("endDate")){
                return {
                    from: moment.parseZone(this.presetdata.startDate),
                    until: moment.parseZone(this.presetdata.endDate),
                };
            }else{
                return {from: this.form.from, until: this.form.until};
            }
        },


        getData() {
            return this.gridData.map((item) =>
                Object.assign({ inEdit: item.ProductID === this.editID }, item)
            );
        },
        result: {
            get: function () {
                return process(this.gridData, {
                    sort: this.sort,
                    filter: this.filter,
                    take: this.take,
                    skip: this.skip,
                });
            },
        },
    },
    mounted(){
        this.init();
    },
    methods:{
        init: function () {

            // Alle Felder laden und zu gridComumns (der Spaltendefinition) hinzufügen
            // Erst felder vorausladen, dann store laden
            this.preloadFields().then(()=>{
                this.$refs.grid.gridInstance.columns.autoAddField = true;
                this.$refs.grid.gridInstance.store.load().then(() =>{
                    this.loadFields();
                });

            });
        },

        leaving: function () {
            //this.saveGridState('ashrms-rms-objects-grid-state');
        },


        preloadFields: async function(fieldsId = null){
            console.log("preloadFields: erst fields preload");
            if (fieldsId != null) {
                console.log("preloadFields: lade einzelne Definition");
                return axios.get('/api/rmsobjects/fieldsdefinitions/id/' + fieldsId)
                    .then(response => {
                        this.preloadedFields = response.data.field_type;
                    });
            }else{
                console.log("preloadFields: lade alle felder");
                return axios.get('/api/rmsobjects/fields')
                    .then(response => {
                        this.preloadedFields = response.data;
                    });
            }
        },

        // region Dynamische Spalten
        loadFields: function (fieldsId = null) {
            if (fieldsId != null) {
                console.log("loadFields: einzelne Definition");
                this.addFields(this.preloadedFields);
            } else {
                console.log("loadFields: preloaded fields zuweisen");
                this.addFields(this.preloadedFields);
            }
            this.initStates();
        },

        addFields: function (customFields) {
            // Alle Spalten entfernen
            this.$refs.grid.gridInstance.columns.removeAll();

            // Basis-Spalten hinzufügen
            this.$refs.grid.gridInstance.columns.add(this.gridConfig.baseColumns)


            let that = this;
            customFields.map(function (value, key) {
                if (value.configuration.model != 'name' && value.configuration.model != 'desc') {

                    let tmpObj = {
                        text: that.$t("cstrings.colfields."+value.configuration.label),
                        field: 'form_data.' + value.configuration.model,
                        editor: false
                    };
                    that.$refs.grid.gridInstance.columns.add(JSON.parse(JSON.stringify(tmpObj)));

                }
            });

            // Als letztes die Action-Spalten hinzufügen
            this.$refs.grid.gridInstance.columns.add(this.gridConfig.actionColumn);
            this.$refs.grid.gridInstance.columns.commit();
        },

        /**
         * Fügt Funktionalität für States des Grids hinzu
         */
        initStates: function () {
            console.log("initstates geladen");
            //this.saveGridState('ashrms-rms-objects-grid-state-default');

            // Falls eine Gridkonfiguration vorhanden ist, diese laden
            //this.loadGridState('ashrms-rms-objects-grid-state');

            // Listener für Gridstate hinzufügen
            this.$refs.grid.gridInstance.columns.on({
                change: _.debounce(({action, records: columns}) => {
                    //this.saveGridState('ashrms-rms-objects-grid-state');
                    // Wenn nicht der default state gesichert wird, den zurücksetzen button deaktiviert
                    this.$refs.grid.gridInstance.widgetMap.clearButton.enable();
                },500)
            });
        },

        onQuickFilterSelect: function (combo, record) {
            // Wenn Alle Elemente des Filters entfernt wurden, Filter zurücksetzen und verlassen
            if (record == undefined) {
                this.onFilterReset();
                return;
            }

            if (combo.selecting) {
                return;
            }

            if (record) {
                // Spezifische Spalten laden
                // Todo: Wenn mehrere Einträge gewählt wurden, eigentlich nicht alle Spalten laden sondern nur die der benötigten
                // Todo: Fehler - Aktuell und durch den State würden die Inhalte neu geladen werden
                /*if(record.length == 1){
                    this.loadFields(record[0].value);
                }else{
                    this.loadFields();
                }*/

                this.$refs.grid.gridInstance.store.filter(
                    {
                        filters: {
                            id: 'field_set_definition_id_' + record.value,
                            property: 'field_set_definition_id',
                            operator: '=',
                            value: record.value
                        },
                        replace: true
                    }
                );

                combo.selecting = false;
            } else {
                // Alle Felder wieder herstellen
                this.loadFields();
                //this.onFilterReset();
            }
        },


        onCreateOrderAction: function (id) {
            console.log("create Order action", id);
            //location.href = "/orders/create/o/" + id;
            this.$router.push({ name: 'order-create', params:
                    {
                        rmsobjectid: id,
                        mode: 'create'
                    } });
        },
        onViewAction: function (id) {
            console.log("view action", id);
            //location.href = "/objects#/objects-details/" + id;
            this.$router.push({ name: 'objects-details', params:
                    {
                        rmsobjectid: id,
                        mode: 'display'
                    } });
        },

        itemChange: function (e) {
            const data = this.gridData.slice();
            const index = data.findIndex((d) => d.ProductID === e.dataItem.ProductID);
            data[index] = { ...data[index], [e.field]: e.value };
            this.gridData = data;
            if (event.dataItem) {
                event.dataItem[e.field] = e.value;
            }
        },
        rowClick: function (e) {
            this.gridData.map((item) => (item.inEdit = false));
            this.editID = e.dataItem.ProductID;
            e.dataItem.inEdit = true;
        },
        closeEdit(e) {
            if (e.target === e.currentTarget) {
                this.editID = null;
            }
        },
        addRecord() {
            const newRecord = { ProductID: this.gridData.length + 1 };
            const data = this.gridData.slice();
            data.unshift(newRecord);
            this.gridData = data;
            this.editID = newRecord.ProductID;
        },
        sortChangeHandler(event) {
            this.sort = event.sort;
        },
        filterChangeHandler(event) {
            this.filter = event.filter;
        },
        pageChangeHandler(event) {
            this.take = event.page.take;
            this.skip = event.page.skip;
        },

        onMenuSelect(event){
          console.log(event);
          this.activeChart = event.item.value;
        },



        onHorizontalChange(event) {
            this.horizontalPanes = event.newState;
        },
        onVerticalChange(event) {
            this.verticalPanes = event.newState;
        },




        onDatePickerLoaded: function (dates) {
            console.log("Picker loaded with dates", dates);
            this.form.dates = dates;
            this.form.from = dates.from;
            this.form.until = dates.until;
        },

        onDateChange: function (dates) {
            console.log("Zeitraum geändert", dates);
            this.form.dates = dates;
            this.form.from = dates.from;
            this.form.until = dates.until;

            console.log("Lade Statistik neu");
            // Nur den Object Picker neu laden, wenn auch direkt equipment gewählt werden soll
            if(this.form.request_equipment_select_type =='specific')
                this.$refs.objectpicker.reloadStore();

        },

    }
}
</script>

<style scoped>

</style>
